import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import {
  EnterpriseSearchService,
  RailOriginalResultsFetcher,
  ServiceType
} from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-rail-results',
  templateUrl: './rail-results.component.html',
  styleUrls: ['./rail-results.component.css'],
  standalone: false
})
export class RailResultsComponent implements OnInit {
  @Input() isAirportExpress = false;
  gettingFareRules = false;
  ServiceType: typeof ServiceType = ServiceType;
  searchParams = this.searchService.searches[ServiceType.Rail];

  /** True while a cached AI rail-search result set (see `resultsId`) is loading. */
  loadingOriginalResults = false;
  /** Bound to `RailEnterpriseSearch.originalResultsNotFound` — true once the
   *  `resultsId` load attempt comes back empty/expired. */
  originalResultsNotFound$: Observable<boolean> = this.searchParams.originalResultsNotFound;

  constructor(
    public searchService: EnterpriseSearchService,
    private route: ActivatedRoute,
    private railOriginalResultsFetcher: RailOriginalResultsFetcher
  ) {}

  ngOnInit(): void {
    // The AI rail-search agent hands the user a `/results/rail?results=<uuid>`
    // link (see request-handler's `rail.searchOriginal`/`getRailSearchOriginalResults`).
    // When present, fetch that cached result set instead of relying on results
    // already sitting in the search service from a live search.
    const resultsId = this.route.snapshot.queryParamMap.get('results');
    if (resultsId) {
      this.loadingOriginalResults = true;
      this.searchParams
        .loadOriginalResults(resultsId, this.railOriginalResultsFetcher)
        .finally(() => {
          this.loadingOriginalResults = false;
        });
    } else {
      // A normal search after an expired link must not keep showing the expired message
      this.searchParams.originalResultsNotFound.next(false);
    }
  }
}
